<ng-container *ngIf="!auth.isLoggedIn()">
    <div *ngIf="showLoadingIndicator" class="text-center mt-5">
        <app-spinner></app-spinner>
    </div>
    <router-outlet></router-outlet>
</ng-container>

<ng-container *ngIf="auth.isLoggedIn()">
    <app-side-navbar *ngIf="!IsMemberPrivilagePlan">
        <div class="text-center mt-5" *ngIf="showLoadingIndicator">
            <app-spinner></app-spinner>
        </div>
        <router-outlet *ngIf="!showLoadingIndicator"></router-outlet>
    </app-side-navbar>

    <router-outlet *ngIf="IsMemberPrivilagePlan"></router-outlet>
    <div *ngIf="showLoadingIndicator" class="text-center mt-5">
        <app-spinner></app-spinner>
    </div>
</ng-container>